import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'html-card',
    name: "HTML Card",
    description: 'A widget to show html content',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-html-card" */ "./HTMLCardTemplate")),
    icon: generateIconProp('html5'),
    complexity: 'medium',
});
